import * as angular from 'angular';
import { isEmpty } from 'lodash';
import { SignInOption } from '~/modules/sign-in/types/sign-in-option.type';
import { getCsrfToken } from '@mode/shared/util-js';
import { FeatureFlag, FeatureFlagsFacade } from '@mode/shared/contract-common';
import { first } from 'rxjs/operators';
import { formSubmit } from '@mode/legacy/data-access-model-js';

export const SignInOptionsPasswordFormComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = ['SignInService', '$sce', '$window', 'FeatureFlagsFacade'];
    private email: string;
    private password: string;
    private emailIsValid: boolean;
    private passwordIsValid: boolean;
    private defaultEmail: string;
    private option: SignInOption;
    private actionUrl: string;
    private authToken: string;
    private redirectUrl: string;
    private loggedOutSignInFlowEnabled: boolean;

    constructor(
      private SignInService,
      private $sce,
      private $window,
      private featureFlagsFacade: FeatureFlagsFacade
    ) {
      this.featureFlagsFacade
        .asObservable(FeatureFlag.LoggedOutSignInFlow)
        .pipe(first())
        .subscribe((enabled) => {
          this.loggedOutSignInFlowEnabled = enabled;
        });
    }

    $onInit() {
      this.emailIsValid = true;
      this.passwordIsValid = true;
      this.email = this.defaultEmail;
      // get and trust the action url for form
      this.actionUrl = this.$sce.trustAsResourceUrl(this.option.url);
      this.authToken = this.getAuthToken();
    }

    getAuthToken() {
      return getCsrfToken(this.$window.document);
    }

    validateEmailInput() {
      this.emailIsValid = !isEmpty(this.email);
    }

    validatePasswordInput() {
      this.passwordIsValid = !isEmpty(this.password);
    }

    handleKeyPress($event) {
      const code = $event.which || $event.keyCode || $event.charCode;
      // if they users keypress is the 'enter' key
      if (code === 13) {
        // then handle the users sign in
        this.handleSignIn($event);
      }
    }

    handleSignIn($event) {
      $event.preventDefault();
      this.validateEmailInput();
      this.validatePasswordInput();

      // if the email and password are both valid
      if (this.passwordIsValid && this.emailIsValid) {
        // then submit the form
        this.submitSignInForm();
      }
    }

    submitSignInForm() {
      formSubmit(this.actionUrl, {
        fields: {
          auth_key: this.email,
          authenticity_token: this.authToken,
          password: this.password,
          ...(this.loggedOutSignInFlowEnabled && this.redirectUrl && { redirect_to: this.redirectUrl }),
        },
      });
    }
  },
  controllerAs: 'ctrl',
  bindings: {
    option: '<',
    defaultEmail: '<',
    redirectUrl: '<',
  },
  template: `
  <div class="sign-in-password-form-container">
    <label class="input-label" for="auth_key">Email or username</label>
    <input
      name="auth_key"
      id="auth_key"
      class="form-control email-form"
      autofocus="autofocus"
      maxlength="255"
      placeholder="Enter your email..."
      ng-model="ctrl.email"
      ng-keypress="ctrl.handleKeyPress($event)"
      >
    </input>

    <div class="password-label-and-link">
      <label class="input-label" for="password">Password</label>
      <a class="forgot-pw-link" href="/password/forgot">Forgot your password?</a>
    </div>
    <input
      type="password"
      name="password"
      id="password"
      class="form-control password-form"
      autofocus="autofocus"
      maxlength="255"
      placeholder="Enter your password..."
      ng-model="ctrl.password"
      ng-keypress="ctrl.handleKeyPress($event)"
      data-test="password-input"
      >
    </input>

    <div class="form-control-error" ng-show="!ctrl.emailIsValid" ng-cloak>
      <div>Please provide a valid email or username.</div>
    </div>

    <div class="form-control-error" ng-show="!ctrl.passwordIsValid" ng-cloak>
      <div>Please enter in your password.</div>
    </div>

    <button class="btn-lg btn-filled-primary sign-in-button" ng-click="ctrl.handleSignIn($event)" data-test="sign-in">
      Sign In
    </button>
  </div>
  `,
};
